export default __webpack_public_path__ + "static/media/Y5.8b33228d.jpg";